import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/site/SmoothScroll";
import { AuthProvider } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Access from "@/pages/Access";
import AppShell from "@/pages/AppShell";
import DemoWorkspace from "@/pages/DemoWorkspace";
import RealOpportunity from "@/pages/RealOpportunity";
import Admin from "@/pages/Admin";
import AdminAdoption from "@/pages/AdminAdoption";
import AcceptInvite from "@/pages/AcceptInvite";
import JoinTeam from "@/pages/JoinTeam";
import InvestorsPathway from "@/pages/InvestorsPathway";
import CompaniesPathway from "@/pages/CompaniesPathway";
import PublicSample from "@/pages/PublicSample";
import LiveStart from "@/pages/LiveStart";
import RetentionNotice from "@/pages/RetentionNotice";
import Pricing from "@/pages/Pricing";
import { CheckoutSuccess, CheckoutCancelled } from "@/pages/Checkout";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App min-h-screen bg-iv-bg text-iv-fg">
      <AuthProvider>
        <BrowserRouter>
          <SmoothScroll>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/investors" element={<InvestorsPathway />} />
              <Route path="/companies" element={<CompaniesPathway />} />
              <Route path="/sample" element={<PublicSample />} />
              <Route path="/live/start" element={<LiveStart />} />
              <Route path="/legal/retention" element={<RetentionNotice />} />
              <Route path="/pricing/investor" element={<Pricing pathway="investor" />} />
              <Route path="/pricing/company" element={<Pricing pathway="company" />} />
              <Route path="/checkout/success" element={<CheckoutSuccess />} />
              <Route path="/checkout/cancelled" element={<CheckoutCancelled />} />
              <Route path="/legal/privacy" element={<Privacy />} />
              <Route path="/legal/terms" element={<Terms />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/access" element={<Access />} />
              <Route path="/access/verify" element={<Access />} />
              <Route path="/pilot" element={<Navigate to="/access" replace />} />
              <Route path="/apply" element={<Navigate to="/access" replace />} />
              <Route path="/login" element={<Login />} />
              <Route path="/invite/:token" element={<AcceptInvite />} />
              <Route path="/join/:token" element={<JoinTeam />} />
              <Route path="/app" element={<AppShell />} />
              <Route path="/app/demo" element={<DemoWorkspace />} />
              <Route path="/app/demo/opportunities/:id" element={<RealOpportunity />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/admin/pilot-applications" element={<Admin />} />
              <Route path="/admin/adoption" element={<AdminAdoption />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </SmoothScroll>
          <Toaster
            position="bottom-right"
            theme="light"
            toastOptions={{
              style: {
                background: "#faf6ec",
                border: "1px solid rgba(20,21,19,0.18)",
                color: "#141513",
                fontFamily: "'Manrope', sans-serif",
                borderRadius: "2px",
              },
            }}
          />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
